import "@babel/polyfill";
import "mutationobserver-shim";
import { createApp } from "vue";
import App from "./App.vue";
import { init } from "emailjs-com";

// Fixed imports for BootstrapVueNext
import BootstrapVueNext from "bootstrap-vue-next";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";

// Imports for vue-toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Initialize your services
init(process.env.VUE_APP_EMAILJS_KEY);

const app = createApp(App)
  .use(BootstrapVueNext)
  .use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true
});

app.mount("#app");
